export default __webpack_public_path__ + "static/blob7-2db3822a3850f0e2e699df992959b697.svg";